import { Flex, Text } from "@chakra-ui/react";
import { SetStateAction } from "react";
import { Button, CardBalance, Icon, Pills } from "barte-design-system";
import { CheckCircle, Clock, Info } from "@phosphor-icons/react";
import { stripCurrency } from "@/utils";
import ModalAntecipacao from "./_ModalAntecipation";
import { hasWithdrawPermission, isWithdrawDisabled } from "./_withdrawRules";

interface SaldoComponentProps {
    data?: any;
    open?: React.Dispatch<SetStateAction<boolean>>
    openTransferList?: React.Dispatch<SetStateAction<boolean>>
    setUpdatedRedeens: React.Dispatch<SetStateAction<number>>
    updatedRedeens?: number
}

const cardHorizontalLayoutSx = {
    ".finance-balance-card > div": { flexDirection: "row", alignItems: "stretch" },
    ".finance-balance-card > div > *": { flex: "1 1 0", minWidth: 0 },
    ".finance-balance-card > div > *:nth-of-type(2)": {
        flex: "0 0 auto",
        width: "var(--border-width-sm)",
        height: "auto",
        alignSelf: "stretch",
    },
    ".finance-info-antecipacao > div:first-of-type": { justifyContent: "space-between" },
    ".finance-info-antecipacao > div:last-of-type": { flex: "0 0 auto", alignItems: "flex-start", justifyContent: "flex-end" },
    ".finance-info-saldo > div:first-of-type": { justifyContent: "space-between" },
    ".finance-info-saldo > div:last-of-type": { flex: "0 0 auto", alignItems: "flex-start", justifyContent: "flex-end" },
};

export function SaldoComponentAntecipation({ data, open, setUpdatedRedeens, updatedRedeens }: SaldoComponentProps) {
    const canWithdraw = hasWithdrawPermission();
    return (
        <Flex w="100%" sx={cardHorizontalLayoutSx}>
            <CardBalance color="white" className="finance-balance-card">
                <CardBalance.Info
                    className="finance-info-antecipacao"
                    variant="big"
                    title="Lançamentos futuros"
                    balance={stripCurrency(data?.onDemandNetAmount)}
                    showIcon={false}
                    pills={<Pills label="Pode antecipar" variant="light" state="accent" size="sm" />}
                    rightSlot={
                        <ModalAntecipacao
                            updatedRedeens={updatedRedeens}
                            setUpdatedRedeens={setUpdatedRedeens}
                            data={data}
                        />
                    }
                    bottomSlot={
                        <Flex align="center" gap="4px">
                            <Icon icon={Info} size={16} weight="bold" color="var(--content-tertiary)" />
                            <Text fontSize="xs" whiteSpace="nowrap" color="var(--content-tertiary)">
                                Valor antecipado ficará disponível para saque
                            </Text>
                        </Flex>
                    }
                />
                <CardBalance.Info
                    className="finance-info-saldo"
                    variant="big"
                    title="Saldo atual"
                    balance={stripCurrency(data?.totalAmount)}
                    showIcon={false}
                    pills={<Pills label="Pode sacar" variant="light" state="success" size="sm" />}
                    rightSlot={
                        <Button size="base" round="full" disabled={isWithdrawDisabled(data, canWithdraw)} onClick={() => open?.(true)}>
                            Solicitar saque
                        </Button>
                    }
                    bottomSlot={
                        <Flex gap="16px" align="center">
                            <Flex align="center" gap="4px" flexShrink={0}>
                                <Icon icon={CheckCircle} size={16} weight="bold" color="var(--content-tertiary)" />
                                <Text fontSize="xs" whiteSpace="nowrap" color="var(--content-secondary)">
                                    Disponível para saque: <Text as="span" fontSize="xs" fontWeight="600" color="var(--content-primary)">{data?.amount}</Text>
                                </Text>
                            </Flex>
                            <Flex align="center" gap="4px" flexShrink={0}>
                                <Icon icon={Clock} size={16} weight="bold" color="var(--content-tertiary)" />
                                <Text fontSize="xs" whiteSpace="nowrap" color="var(--content-secondary)">
                                    A liberar: <Text as="span" fontSize="xs" fontWeight="600" color="var(--content-primary)">{data?.provisionedAmount}</Text>
                                </Text>
                            </Flex>
                        </Flex>
                    }
                />
            </CardBalance>
        </Flex>
    )
}
